module.exports = __webpack_public_path__ + "static/media/Apple.94ace8cd.svg";